module.exports = __webpack_public_path__ + "media/tadah_19.1f00ad7a.wav";